import { ComponentLocations } from 'src/analytics/trackingTypes';
import {
  useActivePaperTablets,
  useCheckoutAllowed,
  useHasSubscription,
  useSubscription,
} from 'src/api/queries';
import { SomethingWentWrong, Spinner } from 'src/components';
import { ActiveSubscriptionHero } from 'src/components/ActiveSubscriptionHero';
import { ConnectOffer } from 'src/components/Offers/ConnectOffer';
import { DmOffer } from 'src/components/Offers/DmOffer';
import { SubscribeHero } from 'src/components/Offers/SubscribeHero';
import { WinbackOffer } from 'src/components/Offers/WinbackOffer';
import { WelcomeAndPairDeviceHero } from 'src/components/WelcomeAndPairDeviceHero';
import {
  CHECKOUT_OFFER_TYPES,
  getActiveOffer,
} from 'src/utils/checkoutHelpers';

export function Hero() {
  const subscription = useSubscription();
  const hasSubscription = useHasSubscription();
  const activePaperTablets = useActivePaperTablets();
  const checkoutAllowed = useCheckoutAllowed({ select: getActiveOffer });

  if (
    subscription.isPending ||
    hasSubscription.isPending ||
    activePaperTablets.isPending ||
    checkoutAllowed.isPending
  ) {
    return <Spinner />;
  }

  if (
    subscription.isError ||
    !!hasSubscription.error ||
    activePaperTablets.isError ||
    checkoutAllowed.isError
  ) {
    return (
      <SomethingWentWrong
        error={
          subscription.error ||
          hasSubscription.error ||
          activePaperTablets.error ||
          checkoutAllowed.error
        }
      />
    );
  }

  if (!activePaperTablets.data.length) {
    return <WelcomeAndPairDeviceHero />;
  }

  if (hasSubscription.data) {
    return (
      <ActiveSubscriptionHero
        activePaperTablets={activePaperTablets.data.length}
        subscription={subscription.data}
      />
    );
  }

  const componentLocation = `${ComponentLocations.FRONT_PAGE.HERO}-${checkoutAllowed.data?.checkoutType}`;

  if (checkoutAllowed.data?.checkoutType === CHECKOUT_OFFER_TYPES.DM) {
    return (
      <DmOffer
        componentLocation={componentLocation}
        freeTrialLengthDays={checkoutAllowed.data.freeTrialLengthDays}
      />
    );
  }

  if (checkoutAllowed.data?.checkoutType === CHECKOUT_OFFER_TYPES.CONNECT) {
    return (
      <ConnectOffer
        componentLocation={componentLocation}
        freeTrialLengthDays={checkoutAllowed.data.freeTrialLengthDays}
      />
    );
  }

  if (checkoutAllowed.data?.checkoutType === CHECKOUT_OFFER_TYPES.WINBACK) {
    return (
      <WinbackOffer
        componentLocation={componentLocation}
        freeTrialLengthDays={checkoutAllowed.data.freeTrialLengthDays}
      />
    );
  }

  return <SubscribeHero componentLocation={componentLocation} />;
}
